import React from "react";
import Form from 'react-bootstrap/Form'
import home_banner from "../../../assets/images/home_banner.png";
function Banner() {
  return (
    <div>
      <div className="banner_section">
        <div className="img_area">
          <img src={home_banner} />
        </div>
        <div className="container">
          <div className="row">
            <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="subscribe">
                <div className="left">
                    <Form>
                      <Form.Group className="form_search" controlId="exampleForm.ControlInput1">
                        <Form.Control type="email" placeholder="Course, University" />
                      </Form.Group>
                    </Form>
                </div>
                <div className="right">
                    <Form>
                      <Form.Group className="form_search" controlId="exampleForm.ControlInput1">
                        <Form.Control type="email" placeholder="Location" />
                      </Form.Group>
                      <div className="subscribe_btn  d-sm-block d-none">
                        <button className="btn-primary-2" type="submit">
                          Subscribe
                        </button>
                      </div>
                    </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
